import { gql } from "@apollo/client";

// OUTLET keyword groups back the store-based conditional outcomes: each group is a
// Store and its `category` is the Store Group. We need `category`, `keywords`, and
// `metadata` together, which no existing keyword-group query selects.
//
// `filters` maps to admin-bff `KeywordGroupFilter` (ADO 26708962): `{ category,
// metadataFilters: [{ path, value }] }`. `type` stays a separate top-level arg — the
// BFF signature is `listKeywordGroups(type: String, filters: KeywordGroupFilter)`, so
// it must NOT be moved into `filters`. Metadata filters apply server-side as
// `metadata.<path> = value` (equality, AND-combined). Omit `filters` to fetch the full
// unfiltered OUTLET list used to derive the Store Group (category) list client-side.
export const getOutletKeywordGroups = gql`
  query GetOutletKeywordGroups($filters: KeywordGroupFilter) {
    listKeywordGroups(type: "OUTLET", filters: $filters) {
      id
      name
      type
      slug
      imageUrl
      category
      categories
      keywords
      metadata
    }
  }
`;
